// extracted by mini-css-extract-plugin
export var tableOfContent = "TableOfContent-module--tableOfContent--7dad0";